module.exports = __webpack_public_path__ + "static/img/ruanzhuda.22779a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ruanzhuda.jpg
// module id = oCys
// module chunks = 1